import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Label } from 'reactstrap';

import { Form, Input, Row, Col } from 'antd';
import { InputList } from './input-list';
/* eslint-disable no-console */

/* eslint no-eval: 0 */

export const QuestionControl = props => {
  const [form] = Form.useForm();

  const onValuesChange = (_, allValues) => {
    // eski handleChange mantığı
    console.log(allValues);
  };
  const selectedColor = 'primary';
  const [cssColor, setCssColor] = useState(selectedColor);
  const [inputValue, setInputValue] = useState(Object());
  const [inputValueList, setInputValueList] = useState(-1);

  const handleChange = event => {
    props.handleData(event);

    // inputValue[  event.target.id] = event.target.value;
    // console.log(event);
  };

  const handleChangemaster = event => {
    console.warn(event.target.value);
    props.handleData(event);
    // inputValue[  event.target.id] = event.target.value;
    // console.warn(inputValue);
  };

  console.log(props.buttons);

  return (
    <div style={{ marginLeft: '1px', width: '80%' }}>
      <Form form={form} layout="vertical" initialValues={props.savedData} onValuesChange={onValuesChange}>
        {props.buttons.map(control => (
          <Row key={control.text} gutter={16} align="middle">
            <Col style={{ marginLeft: '140px' }}>{control.text}</Col>

            {'parent' in control ? (
              <Col flex="auto">
                <InputList
                  match={{
                    isExact: false,
                    path: '',
                    url: '',
                    params: {
                      id: control.parent.startsWith('value:') ? props.handleDataGet(control.parentvalue) : `${control.parent}`,
                      data: props.handleDataGet(`Controller_${control.text}`),
                      placeholder: control.placeholder,
                      name: `Controller_${control.text}`,
                      onChange: handleChangemaster,
                    },
                  }}
                />
              </Col>
            ) : (
              <Col flex="auto">
                <Form.Item name={`Controller_${control.text}`} rules={[{ required: true, message: `${control.text} zorunludur` }]}>
                  <Input type={control.type} placeholder={control.text} />
                </Form.Item>
              </Col>
            )}
          </Row>
        ))}
      </Form>
    </div>
  );
};
